<template>
    <mega-dropdown @shown="trackCheckoutStep">
        <cart-icon :item-count="cartData.itemCount" />

        <template slot="dropdown-content">
            <cart
                :initial-cart-data="cartData"
                :dropdown="true"
                :broadband-addons-page-url="broadbandAddonsPageUrl"
                @updated="newCartData => cartData = newCartData"
                @newProductsAdded="trackAddedToCart"
            />
        </template>
    </mega-dropdown>
</template>

<script>
    import CartIcon from './Partials/CartIcon';

    export default {
        components: {
            CartIcon,
        },

        props: {
            initialCartData: {
                type: Object,
                required: true,
            },
            broadbandAddonsPageUrl: {
                type: String,
                required: true,
            },
            shouldTrackAddedProducts: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                cartData: this.initialCartData,
            };
        },
        methods: {
            trackCheckoutStep() {
                const products = [];

                this.cartData.displayItems.forEach(item => products.push(item.gtmProductData));
                this.cartData.subItems.forEach(item => products.push(item.gtmProductData));

                this.$GtmTracker.checkout(products, 1);
            },
            trackAddedToCart(products, addedFromLocation) {
                if (this.shouldTrackAddedProducts) {
                    this.$GtmTracker.addToCart(products, addedFromLocation);
                }

            },
        },
    };
</script>
